import { CustomerSnapshot } from '../../types'
import { BeforeAfterComparison } from './BeforeAfterComparison'
import { CustomerCard } from './CustomerCard'

/**
 * Before/after snapshot of the customer record (logo, legal name, address),
 * shown in the review modal preview. The "before" card is muted; the "after"
 * card (the live-edited proposal) is emphasised with a white background and a
 * subtle shadow.
 */
export const CustomerCardComparison = ({
  before,
  after
}: {
  before: CustomerSnapshot
  after: CustomerSnapshot
}) => (
  <BeforeAfterComparison
    data-testid="customerInfoReview.cardComparison"
    rows={[
      {
        key: 'customer',
        before: (
          <CustomerCard
            customer={before}
            variant="before"
            data-testid="customerInfoReview.card.before"
          />
        ),
        after: (
          <CustomerCard
            customer={after}
            variant="after"
            // The customer step edits a single customer form, so its card is
            // always the one being edited — ring it to match the contacts step.
            highlighted
            data-testid="customerInfoReview.card.after"
          />
        )
      }
    ]}
  />
)
